/** Building the JSON files the app writes out. */

import { DOC_VERSION, type Board } from './types';
import { FORMAT_ID } from './validate';

export interface BoardFile {
  readonly format: string;
  readonly version: number;
  readonly exportedAt: string;
  readonly board?: Board;
  readonly boards?: readonly Board[];
}

export function boardFile(board: Board): BoardFile {
  return {
    format: FORMAT_ID,
    version: DOC_VERSION,
    exportedAt: new Date().toISOString(),
    board,
  };
}

export function backupFile(boards: readonly Board[]): BoardFile {
  return {
    format: FORMAT_ID,
    version: DOC_VERSION,
    exportedAt: new Date().toISOString(),
    boards,
  };
}

export function toJsonText(file: BoardFile): string {
  return `${JSON.stringify(file, null, 2)}\n`;
}

/** A filename safe on every platform, never empty. */
export function safeFilename(name: string, extension: string): string {
  const base = name
    .normalize('NFKD')
    .replace(/[^\w\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-')
    .slice(0, 60)
    .replace(/^-+|-+$/g, '');
  return `${base.length > 0 ? base.toLowerCase() : 'board'}.${extension}`;
}
